<template>
  <div v-show="visible" class="modal__getArhive">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title getArhive__title">Для получения архива выберете данные и укажите ваш Email</h4>
        <button type="button" class="close popap__btn-close" @click="hide">
          <i><img src="/img/ic_close_chip.svg" alt=""></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal__getArhive__text">
          Подготовка архива с данными референсов занимает некоторое время.
          Ваш запрос будет поставлен в очередь на обработку. По завершению создания
          архива на указанную почту будет отправлена ссылка для скачивания файла.
        </p>
        <div v-if="isCategoriesLoading || isProductIdsLoading" class="categories-loading">
          <img src="/img/ic_loading.svg">
        </div>
        <form v-else class="getArhive__form">
          <div class="getArhive__form-inner">
            <ul v-for="(category, categoryName) in getCategories" class="getArhive__form-input-list" :key="categoryName"
                :data-category="categoryName">
              <li class="getArhive__form-input-item getArhive__form-input-item_main">
                <checkbox
                    @input="event => toggleAll(event, categoryName)"
                    :label="category.title"
                    :checked="isAllCategoriesSelected(categoryName)"
                    :disabled="isAllCategoriesDisabled(categoryName)"
                />
              </li>
              <ul class="getArhive__form-input-list-subcategory">
                <li v-for="(subcategory, subcategoryName) in category.subcategories" class="getArhive__form-input-item"
                    :key="subcategoryName">
                  <svg v-tippy="{ arrow : true }" width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg"
                       :title="subcategory.tooltip">
                    <circle cx="10" cy="10" r="9" stroke="#00AC86" stroke-width="2"/>
                    <rect x="9" y="9" width="2" height="6" fill="#00AC86"/>
                    <rect x="9" y="5" width="2" height="2" fill="#00AC86"/>
                  </svg>
                  <checkbox
                      @input="event => toggleCategory(event, subcategoryName, subcategory.title)"
                      :label="subcategory.title"
                      :checked="getSelectedCategories[subcategoryName]"
                      :disabled="!getAvailableCategories[subcategoryName]"/>
                </li>
              </ul>
            </ul>
            <ul class="getArhive__form-input-list" data-category="settings">
              <li class="getArhive__form-input-item getArhive__form-input-item_main">
                <label class="catalog__checkbox-label"><span>Настройка экспорта</span></label>
              </li>
              <li class="getArhive__form-input-item">
                <svg v-tippy="{ arrow : true }" width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                     title="Включать референсы в выгрузку, даже если у них отсутствуют данные">
                  <circle cx="10" cy="10" r="9" stroke="#52CE5F" stroke-width="2"/>
                  <rect x="9" y="9" width="2" height="6" fill="#52CE5F"/>
                  <rect x="9" y="5" width="2" height="2" fill="#52CE5F"/>
                </svg>
                <checkbox
                    @input="toggleArchiveSettings"
                    label="Выгружать пустые референсы"
                    :checked="includeEmpty"/>
              </li>
            </ul>
          </div>

          <div class="getArhive__warning-wrap" v-if="!canSubmit">
            <p>Выберите тип выгружаемых данных</p>
          </div>
          <div class="getArhive__email-wrap" :class="{ 'has-error': errors.email }">
            <input @input="filterEmail($event)" class="getArhive__form-email" type="text" placeholder="Ваш E-mail"
                   v-model.lazy.trim="email">
            <button :disabled="!canSubmit" class="getArhive__form-btn btn greenBtnCondition" type="button"
                    @click="sendRequest">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="6" width="14" height="12" rx="1" stroke="#fff" stroke-width="2"/>
                <path d="M5 7L11.9419 11.9585C11.9766 11.9833 12.0234 11.9833 12.0581 11.9585L19 7"
                      stroke="#fff" stroke-width="2"/>
              </svg>
              Получить архив
            </button>
            <div v-if="errors.email" class="help-block">{{ errors.email }}</div>
            <div class="getArhive__email-list-wrap" v-if="showEmails">
              <table class="getArhive__table-list-">
                <tr v-for="(email, key) in filterEmails" :key="key">
                  <td @click="setEmail(email)"> {{ email }}</td>
                  <td>
                    <button v-if="canDeleteEmail(email)" type="button" class="close popap__btn-close"
                            @click="deleteEmail(email)">
                      <i><img src="/img/ic_close_chip.svg" alt=""></i>
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-backdrop show" @click="hide"></div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox'
import {
  GET_AVAILABLE_CATEGORIES,
  GET_CATEGORIES,
  GET_PRODUCT_IDS,
  SET_SELECTED_CATEGORIES,
  SET_SELECTED_CATEGORY
} from '@/store/actions/archive'
import {mapGetters} from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'archive-modal',
  components: {
    Checkbox
  },
  data() {
    return {
      submiting: false,
      errors: {},
      email: '',
      main_email: null,
      emails: [],
      filterEmails: [],
      productIds: [],
      visible: false,
      action: '',
      includeEmpty: true,
      showEmails: true
    }
  },
  created() {
    this.$store.dispatch(GET_CATEGORIES)
    this.resetModel()
  },
  mounted() {
    this.$root.$on('archive-modal::show', this.show)
  },
  computed: {
    canSubmit() {
      return !this.isCategoriesLoading && !this.submiting && !this.isProductIdsLoading &&
          Object.values(this.getSelectedCategories).some(category => category)
    },
    ...mapGetters([
      'getCategories',
      'isCategoriesLoading',
      'isProductIdsLoading',
      'getSelectedCategories',
      'getAvailableCategories',
      'getSearchParams'
    ])
  },
  methods: {
    isAllCategoriesSelected(group) {
      return !isEmpty(this.getCategories) && Object.keys(this.getCategories[group].subcategories).every(category => !this.getAvailableCategories[category] || this.getSelectedCategories[category])
    },
    isAllCategoriesDisabled(group) {
      return !isEmpty(this.getCategories) && Object.keys(this.getCategories[group].subcategories).every(category => !this.getAvailableCategories[category])
    },
    toggleArchiveSettings(event) {
      if (event.target.checked && this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Экспорт',
          action: this.action,
          label: 'Включать пустые'
        })
      }
      this.includeEmpty = !this.includeEmpty
    },
    toggleAll(event, group) {
      if (event.target.checked && this.$gtm) {
        Object.entries(this.getCategories[group].subcategories).forEach(([categoryId, category]) => {
          if (this.getAvailableCategories[categoryId]) {
            this.$gtm.trackEvent({
              event: 'UA event',
              category: 'Экспорт',
              action: this.action,
              label: category.title
            })
          }
        })
      }
      this.$store.dispatch(SET_SELECTED_CATEGORIES, {group, checked: event.target.checked})
    },
    toggleCategory(event, category, categoryName) {
      if (event.target.checked && this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Экспорт',
          action: this.action,
          label: categoryName
        })
      }
      this.$store.dispatch(SET_SELECTED_CATEGORY, {category, checked: event.target.checked})
    },
    show(productIds) {
      this.resetModel()
      document.body.classList.add('modal-open')
      this.$store.commit(SET_SELECTED_CATEGORIES, {})
      if (Array.isArray(productIds) && productIds.length) {
        this.action = 'Экспортировать выбранные'
        this.$store.dispatch(GET_AVAILABLE_CATEGORIES, productIds)
        this.productIds = productIds
      } else {
        this.action = 'Экспортировать все'
        this.$store.dispatch(GET_PRODUCT_IDS, this.getSearchParams).then(response => {
          this.productIds = response.data
          this.$store.dispatch(GET_AVAILABLE_CATEGORIES, this.productIds)
        })
      }
      this.visible = true
      this.$api.archive.lastEmails().then(response => {
        this.main_email = response.data.main_email
        this.emails = response.data.emails
        this.filterEmails = response.data.emails
        if (this.emails.length === 1) {
          this.email = this.emails[0]
          this.showEmails = false
        }
      }).catch(() => {
      })
    },
    hide() {
      document.body.classList.remove('modal-open')
      this.visible = false
      this.resetModel()
    },
    resetModel() {
      this.errors = {}
      this.email = ''
      this.main_email = null
      this.productIds = []
      this.includeEmpty = true
      this.showEmails = true
      this.emails = []
      this.filterEmails = []
    },
    sendRequest() {
      const categories = Object.entries(this.getSelectedCategories).reduce((allFilters, [category, selected]) => (selected ? [...allFilters, category] : allFilters), [])
      this.$api.archive.requestArchive({
        email: this.email,
        productIds: this.productIds,
        categories,
        includeEmpty: this.includeEmpty
      }).then(() => {
        const email = this.email
        this.hide()
        this.submiting = false
        this.$root.$emit('archive-success-modal::show', email)
      }).catch((error) => {
        this.errors = {}
        if (error.response && error.response.status === 422) {
          error.response.data.forEach((validationError) => {
            this.errors[validationError.field] = validationError.message
          })
        }
        this.submiting = false
      })
    },
    setEmail(email) {
      this.email = email
      this.showEmails = false;
    },
    deleteEmail(email) {
      this.$api.archive.deleteEmail(email)
      let index = this.emails.indexOf(email)
      this.emails.splice(index, 1)
    },
    filterEmail(event) {
      if (event) {
        let query = event.target.value;
        if (query.length > 0) {
          this.email = query
          this.filterEmails = this.emails.filter((element) => {
            return element.includes(query)
          });
          return this.filterEmails
        }
      }
      this.email = ''
      this.filterEmails = this.emails
    },
    canDeleteEmail(email) {
      if (!this.main_email) {
        return true
      }
      return this.main_email !== email
    }
  },
  beforeDestroy() {
    this.$root.$off('archive-modal::show', this.show)
  }
}
</script>